import React, { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery'
import { useForwardingOrg, useCourt } from "../context/contextHooks";
import { getPaymentTypes, getSelectedType} from "./homeFunctions";
import { useStyles } from "../styles/styles";
import useTheme from "@mui/material/styles/useTheme";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import parse from "html-react-parser";

const Options = (props) => {
    const showNext = props.showNext;
    const [pymtTypes, setPymtTypes] = useState(null);
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [selectedType, setSelectedType] = useState(null);
    const [forwardingOrg ,setForwardingOrg] = useForwardingOrg();
    const [court, setCourt] = useCourt();
    const [uiConfig, setUiConfig] = useState(null);
    const handlePaymentType = (e) => {
        const typeKey = e.target.value;
        if (typeKey) {
            if (!selectedType || selectedType.key !== typeKey) {
                const paymentType = getSelectedType(pymtTypes, typeKey);
                setSelectedType(paymentType);
            }
        } else {
            setSelectedType(null);
        }
    }

    const showSelection = () => {
        showNext(selectedType);
    }

    const goBack = () => {
        setCourt(null);
        setForwardingOrg(null);
    }

    useEffect(() => {
        if (forwardingOrg) {
            setPymtTypes(getPaymentTypes(forwardingOrg));
        }
    }, [forwardingOrg])

    useEffect(() => {
        if (pymtTypes && pymtTypes.length === 1) {
            setSelectedType(pymtTypes[0]);
        } else {
            setSelectedType(null);
        }
        if (pymtTypes && !court) setCourt(forwardingOrg);
    }, [pymtTypes])
    useEffect(() => {
        if (court) {
            setUiConfig(court.landingPageConfig);
        } else setUiConfig(null);
    }, [court])

    return (
        <>
            <Grid container spacing={3} justifyContent='center' >
                <Grid item xs={1}>&nbsp;</Grid>
                <Grid item xs={10} sx={{marginTop: uiConfig ? '0' : '1rem'}}>
                    { forwardingOrg && forwardingOrg.inactive ?
                        <>
                            <Typography
                                variant='subtitle2'
                                sx={{...classes.title, marginTop: '1rem', marginLeft: '0', marginRight: '0', lineHeight: smallScreen ? '1.2rem' : '1.4rem', fontSize: smallScreen ? '1rem' : '1.2rem'}}
                            >
                                {`The ${forwardingOrg.courtName} is currently performing maintenance, and online payments are not available at this time.
                                 Please check back later.  To make a payment at another court or agency, click the "Back" button.`
                                }
                            </Typography>
                            <Box component='div' sx={{...classes.root, marginTop: '1rem'}}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<ArrowBackIcon />}
                                    sx={classes.button}
                                    onClick={goBack}
                                >
                                    Back
                                </Button>
                            </Box>
                        </> :
                        <>
                            <Typography
                                variant='subtitle2'
                                sx={{ ...classes.title, marginTop: uiConfig ? '0' : '1rem', marginLeft: '0', marginRight: '0', lineHeight: smallScreen ? '1.2rem' : '1.4rem', fontSize: smallScreen ? '1rem' : '1.2rem' }}
                            >
                                {forwardingOrg && !uiConfig ? (
                                    `You have been forwarded by the ${forwardingOrg.courtName}. Please ${
                                        pymtTypes && pymtTypes.length > 1 ? 'select a payment type and' : ''
                                    } click on the button beginning with "Pay" to continue. If you want to pay a different organization, click "Back" to select the court or agency you wish to pay.`
                                ) : (
                                    (uiConfig && uiConfig.topRightSection) ? parse(uiConfig.topRightSection) : ''
                                )}
                            </Typography>
                            {pymtTypes && pymtTypes.length > 1 &&
                                <FormControl fullWidth sx={{marginTop: '1rem'}}>
                                    <FormLabel>
                                        <Typography variant="subtitle1" component="span" color='primary'>
                                            Payment Type
                                        </Typography>
                                    </FormLabel>
                                    <Select
                                        name='paymentType'
                                        native variant='outlined'
                                        fullWidth
                                        onChange={handlePaymentType}
                                        sx={{height: '2rem'}}
                                    >
                                        <option key='none' value=''>None Selected</option>
                                        { pymtTypes.map((type) => (
                                            <option key={type.key} value={type.key}>{type.description}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            }
                            <Box component='div' sx={{...classes.root, marginTop: '1rem'}}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<ArrowBackIcon />}
                                    sx={{...classes.button, marginLeft: '0'}}
                                    onClick={goBack}
                                >
                                    Back
                                </Button>
                                { selectedType &&
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AddShoppingCartIcon/>}
                                        sx={classes.button}
                                        onClick={showSelection}
                                    >
                                        {selectedType.description}
                                    </Button>
                                }
                            </Box>
                        </>
                    }
                </Grid>
                <Grid item xs={1}>&nbsp;</Grid>
            </Grid>
        </>
    );
}

export default Options;
